import { config } from '@/configs'
import Main from '@/domains/appShell/main/Main'
import { MaintenanceModal } from '@/domains/appShell/maintenance/MaintenanceModal'
import { AuthProviders } from '@/providers/auth.provider'
import { RestQueryProvider } from '@/providers/restQuery.provider'

import { setLocale } from 'yup'
import { fr } from 'yup-locales'

setLocale(fr)

export default function App() {
  return (
    <RestQueryProvider config={config?.api} auth={config?.auth}>
      <AuthProviders>
        <Main />
      </AuthProviders>
      <MaintenanceModal />
    </RestQueryProvider>
  )
}
